import { ArrowRight } from 'lucide-react'
import { HeroAnimation } from './HeroAnimation'

export function Hero() {
    const scrollToWaitlist = () => {
        const element = document.getElementById('waitlist')
        element?.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <section className="relative overflow-hidden pt-16 pb-24 sm:pt-20 sm:pb-32">
            <div className="max-w-6xl mx-auto px-8 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                    {/* Text Content */}
                    <div className="text-center lg:text-left space-y-6 sm:space-y-8">
                        {/* Headline */}
                        <div className="space-y-4">
                            <h1 className="font-display text-4xl sm:text-5xl lg:text-display-xl font-semibold text-ink leading-tight">
                                Stop staring at your closet.
                            </h1>
                            <p className="text-lg sm:text-xl text-ink-tertiary leading-relaxed max-w-xl mx-auto lg:mx-0 px-6 sm:px-0">
                                Tell Michela the plan. Get 3 outfit options in seconds — built from clothes you already own.
                            </p>
                        </div>

                        {/* CTA */}
                        <div className="space-y-4">
                            <button
                                onClick={scrollToWaitlist}
                                className="inline-flex items-center gap-2 px-8 py-4 bg-cta text-white font-semibold text-lg rounded-2xl hover:bg-cta-hover transition-colors duration-200 shadow-lg hover:shadow-xl"
                            >
                                Join waitlist
                                <ArrowRight className="w-5 h-5" />
                            </button>

                            {/* Value prop badges */}
                            <div className="flex flex-wrap justify-center lg:justify-start gap-3 pt-2">
                                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-paper-alt border border-paper-tertiary rounded-full text-sm text-ink-secondary">
                                    <span className="w-1.5 h-1.5 bg-accent-subtle rounded-full"></span>
                                    Uses your clothes
                                </span>
                                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-paper-alt border border-paper-tertiary rounded-full text-sm text-ink-secondary">
                                    <span className="w-1.5 h-1.5 bg-accent-subtle rounded-full"></span>
                                    Weather-aware
                                </span>
                                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-paper-alt border border-paper-tertiary rounded-full text-sm text-ink-secondary">
                                    <span className="w-1.5 h-1.5 bg-accent-subtle rounded-full"></span>
                                    Learns your style
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Animation Area */}
                    <div className="relative h-[400px] sm:h-[500px] lg:h-[600px] flex items-center justify-center">
                        <HeroAnimation />
                    </div>
                </div>
            </div>
        </section>
    )
}
